import React from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Breadcrumbs } from 'js/components/design-system';
import { dataIntegrityBreadcrumbsHistory } from './functions';

const DataIntegrityBreadcrumbs = () => {
  const location = useLocation();
  const { t } = useTranslation();
  return (
    <Breadcrumbs
      className="data-integrity-breadcrumbs"
      history={dataIntegrityBreadcrumbsHistory(t, location)}
    />
  );
};

export default DataIntegrityBreadcrumbs;
